import React, { useState } from "react";
import {
  Box,
  Typography,
  Button,
  Dialog,
  DialogContent,
  CircularProgress,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from "@material-ui/core";
import { Backdrop } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";

const useStyles = makeStyles({
  iconButton: {
    visibility: "hidden",
    fontSize: "14px",
  },
  tableCell: {
    position: "relative",
    cursor: "pointer",
    "&:hover  $iconButton": {
      visibility: "visible",
    },
  },
  iconButtonActive: {
    position: "absolute",
    top: "50%",
    fontSize: "14px",
    transform: "translateY(-50%)",
    visibility: "visible",
    cursor: "pointer",
  },
  table: {
    // width: 0,

    "& .MuiTableCell-root": {
      borderLeft: "1px solid rgba(224, 224, 224, 1)",
    },
    // css to change table row color on mouse hover
    hoverdef: {
      "&:hover": {
        backgroundColor: "rgb(7, 177, 77, 0.42)",
      },
    },
    hover1: {
      "&:hover": {
        backgroundColor: "red",
      },
    },

    // tablebody: {
    //   "&.MuiTableRow-root:last-child td": {
    //     borderLeft: "1px solid #000",
    //   },
    // },
  },
  inputStyle: {
    outline: "none",
    border: "none",
    background: "transparent",
  },
  inputHov: {
    cursor: "pointer",
    color: "blue",
    textDecoration: "underline",
  },
  tabCon: {
    "@media (max-width: 1570px)": {
      width: "max-content !important",
      textAlign: "center",
      // backgroundColor:'pink !important'
    },
  },
  // text: {
  //   color: '#000',
  //   '&:hover': {
  //     color: 'blue',
  //   }
  // }
});
const ThreeWayCheckModal = ({ open, close, message, submit, loading }) => {
  const Paddingstyle = {
    paddingBottom: "10px",
  };

  const classes = useStyles();
  return (
    <Dialog open={open} onClose={close} fullWidth={true}>
      <DialogContent>
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={loading}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            textAlign: "center",
          }}
        >
          <TableContainer
            className="scrollable"
            style={{
              maxHeight: "400px",
              minHeight: "70px",
              overflowY: "auto",
              overflowX: "auto",
            }}
          >
            <Table>
              <TableHead style={{ position: "sticky", top: 0, zIndex: "1" }}>
                <TableRow sx={{ backgroundColor: "#EFF2F4" }}>
                  <TableCell sx={{ fontWeight: "bold", color: "#031C30" }}>
                    <span className={classes.tableCell}>Item</span>
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold", color: "#031C30" }}>
                    <span className={classes.tableCell}>GRN</span>
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold", color: "#031C30" }}>
                    <span className={classes.tableCell}>Mismatch</span>
                  </TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {message?.length > 0 &&
                  message.map((item, index) => {
                    return (
                      <>
                        <TableRow>
                          <TableCell>{item?.Item}</TableCell>
                          <TableCell>{item?.GRN}</TableCell>
                          <TableCell>{item?.Mismatch}</TableCell>
                        </TableRow>
                      </>
                    );
                  })}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            textAlign: "center",
          }}
          m={1}
        >
          <Button variant="outlined" color="secondary" onClick={close}>
            NO
          </Button>
          <Button
            variant="contained"
            color="secondary"
            onClick={submit}
            style={{ marginLeft: "20px" }}
          >
            Yes
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default ThreeWayCheckModal;
